<template>
  <div v-if="!isLoading">
    <div
      class="card"
      :style="{ borderBottomColor: color }">
      <p
        v-for="item in info"
        :key="item.id">
        <b>{{ item.label }}</b> {{ item.value }}
      </p>
    </div>
  </div>
  <div v-else>
    <skeleton />
  </div>
</template>

<script>
import Skeleton from '@/components/skeleton.vue';

export default {
  name: 'CardComponent',
  components: {
    Skeleton,
  },
  props: {
    info: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      default: 'blue-light',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  background-color: #f5f7fa;
  padding: 15px;
  margin: 15px 0 15px 15px;
  max-width: 600px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
  border-bottom: 6px solid color(blue-light);

  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
}
.card > * {
  transition: transform 0.2s ease-in-out; /* Add transition for smooth scaling effect */

  &:hover {
    transform: scale(1.03); /* Increase size to 105% on hover */
  }
}
</style>
